import React, { useState, useCallback } from "react";

import { useSelector, useDispatch } from "react-redux";
import "../styles/MatchDaysList.css";
import Loader from "sulu-admin-bundle/components/Loader";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { postItem, putItem } from "../../../utils/api";
import { matchAdd, matchDayAdd, matchDayFormShow } from "../redux/actions";
import { getInitForm } from "../helpers/getInitForm";
import { mapMatchIds } from "../helpers/mapMatchIds";
import { getReservedMatches } from "../helpers/getReservedMatches";
import { useTranslation } from "react-i18next";

export default function AddMatchBar({
    matchDay,
    isNew = false,
    disabled = false,
}) {
    const dispatch = useDispatch();
    const leagueState = useSelector((state) => state.leagueReducer.data);
    const matchesState = useSelector((state) => state.matchesReducer.data);
    const [addMatchLoading, setAddMatchLoading] = useState(false);
    const [selectVisible, setSelectVisible] = useState(false);
    const { t } = useTranslation();

    const matchIds =
        leagueState !== null ? mapMatchIds(leagueState?.matchDays) : [];

    const getAutocompleteOptions = useCallback(() => {
        if (!leagueState || !matchesState.length) return [];
        const reservedMatches = getReservedMatches(matchIds, matchesState);
        if (reservedMatches.length) {
            return reservedMatches.map((match) => getInitForm(match));
        } else {
            return [];
        }
    }, [leagueState, matchesState, matchIds]);

    const handleAddMatch = useCallback(async (matchId) => {
        const addMatchUrl = `/admin/api/dhbmatchdays/${matchDay?.matchDayKey}`;
        setAddMatchLoading(true);
        try {
            const responseLeagues = await putItem(addMatchUrl, {
                dhbMatch: matchId,
            });
            dispatch(matchAdd(matchDay?.matchDayKey, matchId));
            setAddMatchLoading(false);
            setSelectVisible(false);
        } catch (error) {
            console.log("league Add Error");
            setSelectVisible(true);
            setAddMatchLoading(false);
        }
    }, []);

    const handleAddNewDay = useCallback(async (matchId) => {
        const addMatchDayUrl = `/admin/api/dhbmatchdays`;
        setAddMatchLoading(true);
        try {
            const responseMatchDay = await postItem(addMatchDayUrl, {
                dhbMatch: matchId,
            });
            dispatch(matchDayAdd(responseMatchDay));
            dispatch(matchDayFormShow(false));
            setAddMatchLoading(false);
            setSelectVisible(false);
        } catch (error) {
            console.log("league Add Error");
            dispatch(matchDayFormShow(false));
            setSelectVisible(true);
            setAddMatchLoading(false);
        }
    }, []);

    let barContent;

    if (addMatchLoading) {
        barContent = <Loader size={25} className="add-match-loader" />;
    } else if (!selectVisible) {
        barContent = (
            <Button
                className={`${disabled ? "disabled" : ""}`}
                variant="contained"
                color="success"
                onClick={() => setSelectVisible(true)}
            >
                {`+ ${t("gamedays.matchday_block.add_match_btn")}`}
            </Button>
        );
    } else if (selectVisible) {
        barContent = (
            <Autocomplete
                id="auto-complete"
                className={`add-match-select ${disabled && "disabled"}`}
                options={getAutocompleteOptions()}
                getOptionLabel={(option) =>
                    `${option?.homeTeam} - ${option?.awayTeam} (Spiel ${option?.id})`
                }
                autoComplete
                disableClearable
                includeInputInList
                onChange={(_, match) => {
                    if (match?.id) {
                        isNew
                            ? handleAddNewDay(match?.id)
                            : handleAddMatch(match?.id);
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("gamedays.matchday_block.add_match_input")}
                        variant="standard"
                    />
                )}
            />
        );
    }
    return <div className="add-match-wrap">{barContent}</div>;
}
